import React, {Component} from "react";
import './pop-up.scss'

class PopUp extends Component {
    constructor() {
        super();
    }

    renderTagData = (item) => {
        return (
            <div className="list-alternate">
                {item.practiceArea.length > 0 ?
                    <li className="list">
                        <b>Practice Area</b>: {item.practiceArea.map((item, index) => <span className="list-last-item"
                                                                                            key={index}>{item}<p>, </p></span>)}
                    </li>
                    : null}
                {item.skills.length > 0 ?
                    <li className="list">
                        <b>Skills</b>: {item.skills.map((item, index) => <span className="list-last-item"
                                                                               key={index}>{item}<p>, </p></span>)}
                    </li>
                    : null}
                {item.qualification.length > 0 ?
                    <li className="list">
                        <b>Qualification</b>: {item.qualification.map((item, index) => <span className="list-last-item"
                                                                                             key={index}>{item}<p>, </p></span>)}
                    </li>
                    : null}
                {item.qualificationSpecialization.length > 0 ?
                    <li className="list">
                        <b>Qualification Specialization</b>: {item.qualificationSpecialization.map((item, index) =>
                        <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </li>
                    : null}
                {item.experience.length > 0 ?
                    <li className="list">
                        <b>Experience</b>: {item.experience.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </li>
                    : null}
                {item.businessSegment.length > 0 ?
                    <li className="list">
                        <b>Business Segment</b>: {item.businessSegment.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </li>
                    : null}
                {item.industry.length > 0 ?
                    <li className="list">
                        <b>Industry</b>: {item.industry.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </li>
                    : null}
                {item.certification.length > 0 ?
                    <li className="list">
                        <b>Certificates</b>: {item.certification.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </li>
                    : null}
                {item.location.length > 0 ?
                    <li className="list">
                        <b>Location</b>: {item.location.map((item, index) => <span className="list-last-item"
                                                                                   key={index}>{item}<p>, </p></span>)}
                    </li>
                    : null}
            </div>
        )
    }

    render() {
        const {viewData, handleClose} = this.props;
        const url = 'https://docs.google.com/gview?url=';
        const endURL = '&embedded=true';
        return (
            <div className="popup-container">
                <div className="popup">
                    <div className="close-button" onClick={() => handleClose()}>x</div>
                    <div className="tags-container">
                        <div className="title">Tags:</div>
                        {this.renderTagData(viewData)}
                    </div>
                    <div className="frame-container">
                        {
                            viewData.resumePath && viewData.resumePath.indexOf('.docx') > -1 || viewData.jdPath && viewData.jdPath.indexOf('.docx') > -1
                                ? <iframe className="container"
                                          src={viewData.resumePath ? url + viewData.resumePath+endURL : url + viewData.jdPath+endURL}></iframe>
                                : <iframe className="container"
                                          src={viewData.resumePath ? viewData.resumePath : viewData.jdPath}></iframe>}
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default PopUp;
